import styled, { keyframes } from 'styled-components';
import { Form } from '@unform/web';
import { TabPanel } from '@chakra-ui/react';

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(500px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
`;

const appearFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(500px);
  }
  to {
    opacity: 1;
    transform: translateY(0px);
  }
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  position: fixed;
	top: 0;
  z-index: 6;

  div::-webkit-scrollbar {
    display: none; /* Might be enough */
    background: transparent;
    visibility: hidden;
    width: 0px;
  }
  div {
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
    scrollbar-width: none;
  }

  .active {
    opacity: 1;
    visibility: visible;
    right: 0px;
    animation: ${appearFromLeft} 0.5s;

    @media (max-width: 650px) {
      top: 0px;
      animation: ${appearFromTop} 0.5s;
    }
  }
`;

export const Content = styled.div`
  background: #fff;
  position: fixed;
  right: -450px;
  width: 700px;
  height: 100%;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.3);
  visibility: hidden;
  opacity: 0;
  border-radius: 3px;
  padding: 0 20px 90px;
  transition: all 0.5s ease-out;

  h1 {
    font-weight: 500;
  }
  h2 {
    margin-left: 10px;
    color: #455a64;
  }

	// 850px
  @media (max-width: 53.125rem) {
    right: 0px;
    // top: 800px;
    width: 100%;
    margin-top: 0px;
  }
	// 479px
  @media (max-width: 29.9375rem) {
		padding: 0 10px 0.9rem;
	}
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
	justify-content: space-between; // flex-end;
  position: fixed;
	bottom: top;
  right: 0;
  padding: 5px 15px 0;
  width: 700px;
	// border: 2px solid blue;

  button {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--azul-razio);
    font-weight: 500;

    svg {
      font-size: 20px;
      margin-right: 5px;
    }
  }
`;

export const TabsView = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
	margin-top: 47px;
  // border: 2px solid blue;

  .tabs {
    width: 100%;

    .tab-list {
      .tab {
				font-size: 1.2rem;
        font-weight: 600;
				padding: 2px 10px;

				:first-child {
					// padding-left: 2px;
				}

        :focus {
          box-shadow: 0 0 0 0;
          border: 0 0;
        }
      }
    }

    .tab-panels {
      width: 100%;
      height: 93.5%;
      position: relative;
			padding: 0px 0px;
      // border: 2px solid orange;

      .tab-panel {
        width: 100%;
        padding: 0;

				button {
					font-weight: 600;
					border-radius: 7px;
					padding: 10px 20px;
					margin: 5px 10px;
				}

				.button-cancel {
					background-color: transparent;
					color: var(--red-razio);
					border: 1px solid var(--red-razio);
				}
				.button-save {
					background-color: var(--azul-razio);
					color: #fff;
					border: 1px solid var(--azul-razio);

					&:disabled {
						opacity: 0.6;
						cursor: not-allowed;
					}
				}
      }
    }
  }
`;

export const TabDataBaixa = styled(TabPanel)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
	// border: 2px solid red;

  div.tab-content {
    display: flex;
    flex-direction: column;
    margin-bottom: 70px;
		padding-bottom: 90px;
		width: 100%;
  	height: 100%;
  }

	// 479px
  @media (max-width: 29.9375rem) {
		button {
			font-size: 13px;
			padding: 7px 10px;
			margin: 5px 1px 0;
		}
	}
`;

export const TabTotais = styled(TabPanel)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
	// border: 2px solid red;

  div.tab-content {
    display: flex;
    flex-direction: column;
    margin-bottom: 70px;
		padding-bottom: 90px;
		width: 100%;
  	height: 100%;
  }

	// 479px
  @media (max-width: 29.9375rem) {
		button {
			font-size: 13px;
			padding: 7px 10px;
			margin: 5px 10px 0;
		}
	}
`;

export const TabPagamento = styled(TabPanel)`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
	// border: 2px solid red;

  div.tab-content {
    display: flex;
    flex-direction: column;
    margin-bottom: 70px;
		padding-bottom: 90px;
		width: 100%;
  	height: 100%;
  }

	// 479px
  @media (max-width: 29.9375rem) {
		button {
			font-size: 13px;
			padding: 7px 10px;
			margin: 5px 10px 0;
		}
	}
`;

export const TituloItem = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	border-bottom: 1px solid #d1d2dc;
	padding: 5px 0;

	span {
		color: #353646;
		font-weight: 500;
	}

	h2 {
		color: #455a64;
		padding-right: 10px;
		font-weight: 500;
	}

	:first-child {
		padding-top: 0;
	}
	:last-child {
		border-bottom: 0;
	}
`;

export const FormView = styled(Form)`
  display: flex;
	flex-direction: column;
  width: 100%;
  padding: 0px 0 0;
	// border: 2px solid orange;

	div.input {
		display: flex;
		flex-direction: column;
		width: 100%;
		// padding-right: 10px;
		// border: 2px solid green;

		p {
			font-size: 1rem;
			font-weight: 500;
			margin: 0 0 3px;

			span {
				font-size: 0.8rem;
				color: #455a64;
			}
		}

		span {
			font-size: 0.8rem;
			font-weight: 500;
			color: #455a64;
			text-align: end;
			width: 100%;
			padding: 5px 10px 0 0;
		}
	}

	.radio-group {
		display: flex;
		// flex-direction: column;
		width: 100%;
		padding: 5px 10px;
		// margin-right: 10px;
		border: 1px solid #d1d2dc;
		border-radius: 8px;
		
		.radio-label {
			display: flex;
			align-items: center;
			margin: 0;

			input[type='radio'] {
				margin-right: 0.2rem; // 10px;
				appearance: none;
				font: inherit;
				color: var(--azul-razio);
				width: 1.125rem; // 18px;
				height: 1.125rem; // 18px;
				border: 2px solid var(--gray-border-lw);
				border-radius: 50%;

				:checked {
					border: 5px solid var(--azul-razio);
				}
			}

			label {
				font-size: 0.9375rem; // 15px
				font-weight: 500;
				color: #455a64;
				margin-right: 100px;
			}
		};
	};

	// 479px
  @media (max-width: 29.9375rem) {
		button {
			font-size: 13px;
			padding: 7px 10px;
			margin: 5px 2px 0;
		}
	}
`;

export const Buttons = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  position: fixed;
  bottom: 0;
  right: 0;
  width: 700px;

	.buttons {
		button {
			font-weight: 600;
			border-radius: 7px;
			padding: 10px 20px;
			margin: 5px 10px;
		}

		.button-cancel {
			background-color: transparent;
			color: var(--red-razio);
			border: 1px solid var(--red-razio);
		}
		.button-save {
			background-color: var(--azul-razio);
			color: #fff;
			border: 1px solid var(--azul-razio);

			&:disabled {
				opacity: 0.6;
				cursor: not-allowed;
			}
		}
	}

	// 850px
	@media (max-width: 53.125rem) {
    width: 100%;
  }
	// 479px
  @media (max-width: 29.9375rem) {
		button {
			:first-child {
				margin-right: 0px;
			}

			margin-left: 0px;
		}
	}
`;